<template>
  <div class="paginationLine"/>
</template>

<script>
    export default {
        name: "SeparaterLine"
    }
</script>

<style lang="scss" scoped>
    .paginationLine{
        border-top: 1px solid rgba(0,0,0,0.20);
    }
</style>